import { usePropertyBuildType } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { DropDownBox, DropDownBoxComponentSpacing } from '@apply/components';
import { buildTypeString, buildTypes } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { DropDownBoxLabelSize } from '@apply/components/src/components/controls/DropDownBox';

export interface SiteBuiltOrManufacturedProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    componentSizing?: DropDownBoxComponentSpacing;
    labelSize?: DropDownBoxLabelSize;
}

export const SiteBuiltOrManufactured: React.FC<SiteBuiltOrManufacturedProps> = ({
    propertyGuid,
    required = false,
    readOnly = false,
    isReview = false,
    componentSizing,
    labelSize,
}) => {
    const label = 'Is the property Site Built or Manufactured? ';
    const [buildType, set_buildType] = usePropertyBuildType(propertyGuid);

    const buildTypeList = [
        {
            display: buildTypeString(buildTypes.SiteBuilt),
            value: buildTypes.SiteBuilt,
        },
        {
            display: buildTypeString(buildTypes.Manufactured),
            value: buildTypes.Manufactured,
        },
    ];

    const findBuildTypeByName = (type: number | undefined) => {
        return buildTypeList.find((bt) => bt.value == type)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findBuildTypeByName(buildType)}
                />
            ) : (
                <>
                    <DropDownBox
                        id={'siteBuiltOrManufacturedDropDown'}
                        value={buildType}
                        onChange={(value) => set_buildType(value)}
                        required={required}
                        dataSource={buildTypeList}
                        displayExpr={'display'}
                        valueExpr={'value'}
                        label={label}
                        readOnly={readOnly}
                        componentSpacing={componentSizing}
                        labelSize={labelSize}
                    />
                </>
            )}
        </>
    );
};
